export default function checkCompatibility() {
  return new Promise((resolve, reject) => {
    const DB_NAME = 'doesnt-exist';

    try {
      const indexedDBRequest = indexedDB.open(DB_NAME, 1);

      indexedDBRequest.onerror = (e) => {
        // https://stackoverflow.com/a/45672895
        // this apparently will prevent an InvalidStateError from propogating to airbrake
        if (indexedDBRequest.error && indexedDBRequest.error.name === 'InvalidStateError') {
          e.preventDefault();
        }
        reject();
      };
      indexedDBRequest.onsuccess = () => {
        indexedDB.deleteDatabase(DB_NAME);
        // check if we're in safari
        try {
          localStorage.setItem(DB_NAME, 1);
        } catch (e) {
          // for some reason, safari will let us open a database
          // but not actually put stuff into it
          if (e.name === 'QuotaExceededError') {
            return reject();
          }
        }
        localStorage.removeItem(DB_NAME);
        return resolve();
      };
    } catch (e) {
      reject();
    }
  });
}



// WEBPACK FOOTER //
// ./src/lib/checkCompatibility.js